import calendarRoutes from "@/modules/calendar/routes";
import childrenRoutes from "@/modules/children/routes";
import childrenGroups from "@/modules/childrenGroups/routes";
import classroomsRoutes from "@/modules/classrooms/routes";
import dietsRoutes from "@/modules/diets/routes";
import institutionsRoutes from "@/modules/institutions/routes";
import institutionsWorkersRoutes from "@/modules/institutionsWorkers/routes";
import institutionsWorkersGroupsRoutes from "@/modules/institutionsWorkersGroups/routes";
import mealsMenusFilesRoutes from "@/modules/mealsMenusFiles/routes";
import mealTypesRoutes from "@/modules/mealTypes/routes";
import mealsRoutes from "@/modules/meals/routes";
import mealsMenusRoutes from "@/modules/mealsMenus/routes";
import ordersRoutes from "@/modules/orders/routes";
import parentsRoutes from "@/modules/parents/routes";
import profileRoutes from "@/modules/profile/routes";
import settingsRoutes from "@/modules/settings/routes";
import terminalRoutes from "@/modules/terminal/routes";
import transactionsRoutes from "@/modules/transactions/routes";
import paymentsRoutes from "@/modules/payments/routes";
import priceListsRoutes from "@/modules/priceLists/routes";
import inventoryRoutes from "@/modules/inventory/routes";
import helpTicketsRoutes from "@/modules/helpTickets/routes";
import cooksRoutes from "@/modules/cooks/routes";
import usersRoutes from "@/modules/users/routes";
import institutionsAdminsRoutes from "@/modules/institutionsAdmins/routes";
import invoicesFilesRoutes from "@/modules/invoicesFiles/routes";
import announcementsRoutes from "@/modules/announcements/routes";
import recipientsRoutes from "@/modules/recipients/routes";
import kitchensRoutes from "@/modules/kitchens/routes";
import allergensRoutes from "@/modules/allergens/routes";
import portionSizesRoutes from "@/modules/portionSizes/routes";
import ticketsRoutes from "@/modules/tickets/routes";
import administratorsRoutes from "@/modules/administrators/routes";
import returnRequestsRoutes from "@/modules/returnRequests/routes";
import driversRoutes from "@/modules/drivers/routes";
import routeNumbersRoutes from "@/modules/routeNumbers/routes";
import dailyMealsReleasesRoutes from "@/modules/dailyMealsReleases/routes";
import districtsRoutes from "@/modules/districts/routes";
import mealTypesCategoriesRoutes from "@/modules/mealTypesCategories/routes";
import tenantInvoicesRoutes from "@/modules/tenantInvoices/routes";
import automatedReportsRoutes from "@/modules/automatedReports/routes";
import onlinePaymentsRoutes from "@/modules/onlinePayments/routes";
import ordersImportRoutes from "@/modules/ordersImport/routes";
import externalUsersRoutes from "@/modules/externalUsers/routes";
import experimentalRoutes from "@/modules/experimental/routes";
import institutionGroupsRoutes from "@/modules/institutionGroups/routes";
import recipesRoutes from "@/modules/recipes/routes";

const FullLayout = () => import("../../components/layouts/FullLayout.vue");
const Dashboard = () => import("./views/Dashboard.vue");

const routes = [
  {
    path: "/",
    redirect: "/dashboard",
    name: "home",
    component: FullLayout,

    meta: {
      authorized: true,
    },

    children: [
      {
        path: "dashboard",
        name: "dashboard",
        component: Dashboard,

        meta: {
          roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
        },
      },

      ...calendarRoutes,
      ...childrenRoutes,
      ...childrenGroups,
      ...classroomsRoutes,
      ...dietsRoutes,
      ...administratorsRoutes,
      ...institutionsRoutes,
      ...institutionsWorkersRoutes,
      ...institutionsWorkersGroupsRoutes,
      ...mealsMenusFilesRoutes,
      ...mealsMenusRoutes,
      ...mealTypesRoutes,
      ...mealsRoutes,
      ...ordersRoutes,
      ...parentsRoutes,
      ...profileRoutes,
      ...settingsRoutes,
      ...terminalRoutes,
      ...transactionsRoutes,
      ...paymentsRoutes,
      ...priceListsRoutes,
      ...inventoryRoutes,
      ...helpTicketsRoutes,
      ...cooksRoutes,
      ...institutionsAdminsRoutes,
      ...usersRoutes,
      ...invoicesFilesRoutes,
      ...announcementsRoutes,
      ...recipientsRoutes,
      ...kitchensRoutes,
      ...allergensRoutes,
      ...portionSizesRoutes,
      ...returnRequestsRoutes,
      ...driversRoutes,
      ...routeNumbersRoutes,
      ...dailyMealsReleasesRoutes,
      ...districtsRoutes,
      ...mealTypesCategoriesRoutes,
      ...tenantInvoicesRoutes,
      ...automatedReportsRoutes,
      ...onlinePaymentsRoutes,
      ...ordersImportRoutes,
      ...ticketsRoutes,
      ...externalUsersRoutes,
      ...experimentalRoutes,
      ...institutionGroupsRoutes,
      ...recipesRoutes,
    ],
  },
];

export default routes;
